(function () {
  var MAP = {
    'featured': 'Empfohlen',
    'most relevant': 'Beste Treffer',
    'best selling': 'Bestseller',
    'alphabetically, a-z': 'Name A \u2013 Z',
    'alphabetically, z-a': 'Name Z \u2013 A',
    'price, low to high': 'Preis aufsteigend',
    'price, high to low': 'Preis absteigend',
    'date, old to new': '\u00c4lteste zuerst',
    'date, new to old': 'Neuheiten zuerst',
    'manually': 'Empfohlen',
    'relevance': 'Beste Treffer',
    'sort by': 'Sortieren nach',
    'sort': 'Sortieren'
  };

  function translate(scope) {
    (scope || document).querySelectorAll('select option').forEach(function (o) {
      var k = (o.textContent || '').trim().toLowerCase();
      if (MAP[k]) o.textContent = MAP[k];
    });
    (scope || document).querySelectorAll('label, .facets__label, [class*="sort"] > span').forEach(function (l) {
      var k = (l.textContent || '').trim().toLowerCase();
      if (MAP[k]) l.textContent = MAP[k];
    });
  }

  function boot() {
    translate();
    var main = document.getElementById('MainContent');
    if (main) new MutationObserver(function (m) {
      m.forEach(function (r) {
        r.addedNodes.forEach(function (n) { if (n.nodeType === 1) translate(n); });
      });
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
